import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Permission } from '../../../models/permission.model';
import { roleMS } from '../../../models/roleMS.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { RolePermissionMSService } from '../../../services/utils/rolePermissionMS.service';

@Component({
  selector: 'app-rolesapplication-permissions',
  providers: [],
  templateUrl: './rolesApplicationPermissions.component.html'
})

export class RolesApplicationPermissionsComponent implements OnInit {

  @Input() role: roleMS;
  @Output() onBack: EventEmitter<any> = new EventEmitter();

  customButtons: DataTableCustomButton[];
  permissionsRoleMSTitles: DataTableField[];
  selectedPermissionRoleMS: Permission = null;
  paginationType = KontableComponent.ClientPagination;
  newDataAvailable = false;
  showDetail = false;
  customFilter = KontableComponent.CustomFilter;

  constructor(
    private translate: TranslateService,
    private srvDataTable: DataTableService,
    public srvRolePermissionMS: RolePermissionMSService,
  ) {
    this.translate.get([
        'permissionForm.operationID',
        'permissionForm.operationName',
        'permissionForm.type',
        'permissionForm.allowsGET',
        'permissionForm.allowsPOST',
        'permissionForm.allowsPUT',
        'permissionForm.allowsDELETE',
        'common.back'
    ]).subscribe((res) => {
      this.permissionsRoleMSTitles = [
        {id: 'operationID', label: res['permissionForm.operationID']},
        {id: 'type', label: res['permissionForm.type']},
        {id: 'operationName', label: res['permissionForm.operationName']},
        {id: 'allowsGET', label: res['permissionForm.allowsGET']},
        {id: 'allowsPOST', label: res['permissionForm.allowsPOST']},
        {id: 'allowsPUT', label: res['permissionForm.allowsPUT']},
        {id: 'allowsDELETE', label: res['permissionForm.allowsDELETE']}
      ];
      this.customButtons = [
        {label: res['common.back'], callbackname: 'back', icon: 'fa fa-reply', isAlwaysEnabled: true},
      ];
    });
  }

  ngOnInit(): void {
    this.srvRolePermissionMS.getAll(this.role).subscribe();
  }

  save(rolePermission): void {

    if (!rolePermission.id) {
      this.srvRolePermissionMS.post(this.role, rolePermission).subscribe((res) => {
        this.srvDataTable.get('dt_roles_permissions').showDetail = false;
        this.srvRolePermissionMS.getAll(this.role).subscribe();
      });
    } else {
      this.srvRolePermissionMS.put(this.role, rolePermission).subscribe(() => {
        this.srvDataTable.get('dt_roles_permissions').showDetail = false;
        this.srvRolePermissionMS.getAll(this.role).subscribe();
      });
    }
    this.closeDialogDetail ();
  }

  remove($event): void {
    this.selectedPermissionRoleMS = $event;
    this.srvRolePermissionMS.delete(this.role, this.selectedPermissionRoleMS).subscribe(() => {
      this.srvRolePermissionMS.getAll(this.role).subscribe();
    });
  }

  editPermissionRole($event): void {
    this.showDetail = true;
    this.selectedPermissionRoleMS = $event;
  }

  customButton(): void {
    this.onBack.emit();
  }

  returnValueClumn (row, resource) {
    if ((resource === 'get' && row.allowsGET) ||
        (resource === 'post' && row.allowsPOST) ||
        (resource === 'put' && row.allowsPUT) ||
        (resource === 'delete' && row.allowsDELETE)) {
      return 'pi-check';
    }
    return 'pi-times';
  }

  closeDialogDetail() {
    this.showDetail = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplicationPermissions.component.ts